module.exports = __webpack_public_path__ + "static/media/eggs.5eaa6e4c.jpg";